import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AdServingAssessment"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.2362 5.92104H11.7426V4.47944H19.2362V5.92104zM11.7426 8.03546H16.0247V6.59386H11.7426V8.03546z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.0885 1.5C10.1687 1.5 9.42306 2.25299 9.42306 3.18186V12.2643C9.42306 12.54 9.57875 12.7915 9.82413 12.9123C10.0695 13.033 10.3616 13.0019 10.5766 12.832L13.0591 10.8707H20.4255C21.3453 10.8707 22.0909 10.1177 22.0909 9.18882V3.18186C22.0909 2.25299 21.3453 1.5 20.4255 1.5H11.0885ZM10.8505 3.18186C10.8505 3.04916 10.9571 2.94159 11.0885 2.94159H20.4255C20.5569 2.94159 20.6634 3.04916 20.6634 3.18186V9.18882C20.6634 9.32151 20.5569 9.42908 20.4255 9.42908H12.8131C12.6537 9.42908 12.4988 9.48298 12.3733 9.58217L10.8505 10.7852V3.18186Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.66539 3.08582C3.74562 3.08582 3 3.83881 3 4.76768V20.8181C3 21.747 3.74562 22.5 4.66539 22.5H14.5377C15.4575 22.5 16.2031 21.747 16.2031 20.8181V12.0717H14.7756V18.2232H4.42748V7.98717H8.23408V6.54557H4.42748V4.76768C4.42748 4.63498 4.53399 4.52741 4.66539 4.52741H8.23408V3.08582H4.66539ZM4.42748 19.6648H14.7756V20.8181C14.7756 20.9508 14.6691 21.0584 14.5377 21.0584H4.66539C4.53399 21.0584 4.42748 20.9508 4.42748 20.8181V19.6648Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AdServingAssessment.vue"]]);
